import { FILTER_LABEL } from './types/filter.enums';
import {
  FILTER_OPTIONS_TYPE,
  FILTER_PLACEMENT,
  FILTER_TRIGGER_TYPE,
  FILTER_TYPE,
  FilterConfig,
} from '@/components/uiKit/FiltersGroup/types';

export const notificationPreferencesFilterConfig: FilterConfig = [
  {
    allStaticValues: [],
    initialStaticValues: [],
    fieldName: 'site_name',
    fieldValueToFilterValueMapping: (fieldValue: string) => fieldValue,
    filterOptionsType: FILTER_OPTIONS_TYPE.DYNAMIC,
    filterData: {
      filterLabel: FILTER_LABEL.SITE,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'lg',
      },
      filterOptions: [],
    },
  },
  {
    allStaticValues: [],
    initialStaticValues: [],
    fieldName: 'asset_type',
    fieldValueToFilterValueMapping: (fieldValue: string) => fieldValue,
    filterOptionsType: FILTER_OPTIONS_TYPE.DYNAMIC,
    filterData: {
      filterLabel: FILTER_LABEL.ASSET_TYPE,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'lg',
      },
      filterOptions: [],
    },
  },
  {
    allStaticValues: [],
    initialStaticValues: [],
    fieldName: 'asset_area',
    fieldValueToFilterValueMapping: (fieldValue: string) => fieldValue,
    filterOptionsType: FILTER_OPTIONS_TYPE.DYNAMIC,
    filterData: {
      filterLabel: FILTER_LABEL.ASSET_AREA,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'lg',
      },
      filterOptions: [],
    },
  },
];
